// Recently viewed storage + rendering
const RECENTLY_VIEWED_STORAGE_KEY = 'lq:recently-viewed:v1';
const RECENTLY_VIEWED_MAX = 20;

function safeJsonParse(value, fallback) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
}

function getRecentlyViewed() {
  const raw = window.localStorage?.getItem(RECENTLY_VIEWED_STORAGE_KEY);
  const parsed = safeJsonParse(raw, []);
  return Array.isArray(parsed) ? parsed : [];
}

function setRecentlyViewed(list) {
  try {
    window.localStorage?.setItem(RECENTLY_VIEWED_STORAGE_KEY, JSON.stringify(list));
  } catch (e) {
    // ignore storage failures (quota, privacy mode, etc.)
  }
}

function addRecentlyViewedItem({ handle, id, ts = Date.now() }) {
  if (!handle && !id) return;

  const list = getRecentlyViewed();

  const next = [
    { handle: handle || null, id: id || null, ts },
    ...list.filter((item) => (handle ? item.handle !== handle : true) && (id ? item.id !== id : true)),
  ].slice(0, RECENTLY_VIEWED_MAX);

  setRecentlyViewed(next);
}

async function fetchProductCardHTMLByHandle(handle) {
  const url = `/products/${encodeURIComponent(handle)}?view=recently-view-v1&section_id=recently-viewed-product`;

  const response = await fetch(url, { credentials: 'same-origin' });
  if (!response.ok) throw new Error(`Failed to fetch product card for handle ${handle}`);

  const text = await response.text();
  const doc = new DOMParser().parseFromString(text, 'text/html');
  const card = doc.querySelector('[data-recently-viewed-card]');
  return card ? card.innerHTML : '';
}

class RecentlyViewedTracker extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.productHandle;
    const id = this.dataset.productId ? parseInt(this.dataset.productId, 10) : null;
    addRecentlyViewedItem({ handle, id });
  }
}
if (!customElements.get('recently-viewed-tracker')) {
  customElements.define('recently-viewed-tracker', RecentlyViewedTracker);
}


class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  get columnsDesktop() {
    const n = parseInt(this.dataset.columnsDesktop || '4', 10);
    return Number.isFinite(n) && n > 0 ? n : 4;
  }

  get columnsMobile() {
    const n = parseInt(this.dataset.columnsMobile || '2', 10);
    return Number.isFinite(n) && n > 0 ? n : 2;
  }

  applySliderVisibility(renderedCount) {
    const sliderComponent = this.querySelector('slider-component');
    const ul = this.querySelector('ul[id^="Slider-"]');
    const buttons = this.querySelector('.slider-buttons');

    if (!sliderComponent || !ul) return;

    const desktopMax = this.columnsDesktop;
    const mobileMax = this.columnsMobile;

    const shouldEnableDesktopSlider = renderedCount > desktopMax;
    const shouldEnableMobileSlider = renderedCount > mobileMax;

    const showButtons = shouldEnableDesktopSlider || shouldEnableMobileSlider;
    requestAnimationFrame(() => {
      if (buttons) buttons.style.display = showButtons ? '' : 'none';

      if (shouldEnableDesktopSlider && shouldEnableMobileSlider) {
        ul.classList.add('slider', 'slider--everywhere');
      }
      if (shouldEnableDesktopSlider) {
        ul.classList.add('slider', 'slider--desktop');
        sliderComponent.classList.add('slider-component-desktop');
      } else {
        sliderComponent.classList.remove('slider-component-desktop');
        sliderComponent.classList.add('page-width');
      }
      if (shouldEnableMobileSlider) ul.classList.add('slider', 'slider--tablet',);
    });

    if (typeof sliderComponent.resetPages === 'function') {
      sliderComponent.resetPages();
    }
  }

  async render() {
    const limit = parseInt(this.dataset.limit || '4', 10);
    const currentProductId = this.dataset.productId ? parseInt(this.dataset.productId, 10) : null;

    const items = getRecentlyViewed()
      .filter((item) => (currentProductId ? item.id !== currentProductId : true))
      .sort((a, b) => (b.ts || 0) - (a.ts || 0))
      .slice(0, limit);

    if (!items.length) {
      this.hidden = true;
      return;
    }

    const ul = this.querySelector('ul[id^="Slider-"]');
    if (!ul) {
      this.hidden = true;
      return;
    }

    const slides = [];
    for (let i = 0; i < items.length; i += 1) {
      const handle = items[i].handle;
      if (!handle) continue;

      try {
        const cardHTML = await fetchProductCardHTMLByHandle(handle);
        if (!cardHTML) continue;

        slides.push(`
          <li id="Slide-${this.dataset.sectionId}-${i + 1}" class="grid__item slider__slide" data-cascade style="--animation-order: ${i + 1};">
            ${cardHTML}
          </li>
        `);
      } catch (e) {
        // ignore individual failures
      }
    }

    if (!slides.length) {
      this.hidden = true;
      return;
    }

    ul.insertAdjacentHTML('beforeend', slides.join(''));

    const totalEl = this.querySelector('.slider-counter--total');
    if (totalEl) totalEl.textContent = String(slides.length);

    this.applySliderVisibility(slides.length);

    this.hidden = false;
  }
}
if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}